import * as Sentry from '@sentry/react-router'
import { reactRouterTracingIntegration } from '@sentry/react-router'
import { startTransition, StrictMode } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'

Sentry.init({
	dsn: 'https://452f36b0ade92334f1c44abce26eccfb@o4509349769904128.ingest.de.sentry.io/4510878989418576',
	tracesSampleRate: 1,
	enabled: import.meta.env.MODE === 'production',
	enableLogs: true,
	environment: import.meta.env.MODE,
	integrations: [reactRouterTracingIntegration()],
	sendDefaultPii: true,
})

startTransition(() => {
	hydrateRoot(
		document,
		<StrictMode>
			<HydratedRouter />
		</StrictMode>,
	)
})
